import { useEffect, useState } from "react";
import { select } from "d3-selection";
import {
  forceCenter,
  forceLink,
  forceManyBody,
  forceSimulation,
} from "d3-force";

import { tick } from "./events";
import { addDrag, addHoverOpacity, addZoom } from "./interactions";
import { Button, Col, Row, Spin } from "antd";

const GraphNetwork: React.FC<any> = (props) => {
  const {
    data,
    NodeComponent,
    LineComponent,
    pullIn,
    zoomDepth,
    enableDrag,
    hoverOpacity,
    loading,
    id = "GraphTree_container",
  } = props;
  {
    const [handlerZoomGraph, setHandlerZoomGraph]: any = useState();

    useEffect(() => {
      const createLinks = () => {
        const svg: any = select(`#${id}`);
        const link = svg.selectAll("._graphLine").data(data.links);
        const node = svg.selectAll("._graphNode").data(data.nodes);
        const simulation = forceSimulation(data.nodes)
          .force(
            "link",
            forceLink() // This force provides links between nodes
              .id(function (d: any) {
                return d.id;
              }) // This provide the id of a node
              .links(data.links) // and this the list of links
          )
          .force(
            "center",
            forceCenter(
              svg._groups[0][0].parentElement.clientWidth / 2,
              svg._groups[0][0].parentElement.clientHeight / 2
            )
          ) // This force attracts nodes to the center of the svg area

          .on("tick", () => tick(node, link)); // https://github.com/d3/d3-force#simulation_tick
        return simulation;
      };

      const mount = () => {
        if (!data || loading) {
          return true;
        }
        const svg: any = select(`#${id}`);
        const link = svg.selectAll("._graphLine").data(data.links);
        const node = svg.selectAll("._graphNode").data(data.nodes);
        const simulation = createLinks().force(
          "charge",
          forceManyBody()
            .strength(-1 * 5)
            .distanceMax(data.links.length / 25 + 5)
            .distanceMin(data.links.length / 25)
        ); // This adds repulsion between nodes. Play with the -400 for the repulsion strength

        // add interactions
        addHoverOpacity(node, link, hoverOpacity);
        addDrag(node, simulation, enableDrag, pullIn);
        const zoomGraph = addZoom(svg, zoomDepth);
        const functionZoom = (zoomValue: number) => {
          zoomGraph.scaleBy(svg.transition().duration(750), zoomValue);
        };
        setHandlerZoomGraph(() => functionZoom);
      };

      mount();
    }, [
      data,
      NodeComponent,
      LineComponent,
      loading,
      enableDrag,
      hoverOpacity,
      pullIn,
      zoomDepth,
      id,
    ]);

    if (loading) {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Spin spinning={true} />
        </div>
      );
    }

    if (!data) {
      return null;
    }

    return (
      <>
        <Row>
          <Col xs={24}>
            <Button
              htmlType="button"
              className="filter-button delete"
              onClick={() => handlerZoomGraph(1.2)}
              style={{ float: "right" }}
            >
              +
            </Button>
            <Button
              htmlType="button"
              className="filter-button delete"
              onClick={() => handlerZoomGraph(0.8)}
              style={{ float: "right", marginRight: "5px" }}
            >
              -
            </Button>
          </Col>
        </Row>
        <svg id={id} width="100%" height="100%">
          <g className="_graphZoom">
            {data.links.map((link: any, i: number) => {
              return LineComponent ? (
                <LineComponent link={link} key={i} className="_graphLine" />
              ) : (
                <line stroke="grey" key={i} className="_graphLine" />
              );
            })}
            {data.nodes.map((node: any, i: number) => {
              return (
                <g key={i} className="_graphNode">
                  {NodeComponent ? (
                    <NodeComponent node={node} />
                  ) : (
                    <circle fill="black" r={10} />
                  )}
                </g>
              );
            })}
          </g>
        </svg>
      </>
    );
  }
};

export default GraphNetwork;
